import { RouterProvider } from 'react-router-dom';
import { router } from './router/routes';
import { AnimatePresence } from 'framer-motion';
function App() {
    return (
        <>
            <div className="App">
                <AnimatePresence mode="wait">
                    <RouterProvider router={router} />
                </AnimatePresence>
            </div>
        </>
    );
}

export default App;
